import {Setting} from "../../../setting/Setting";
import {DraftComponent, DraftComponentCategory, DraftElement} from "../../../../../../../feature/Draft";
import {combineSettingDescription} from "../list/SettingList";
import {
    assistantAsking, assistantAskingForAction,
    assistantAskingForContext, assistantAskingForExample,
    assistantAskingForGenre, assistantAskingForInstructions, assistantAskingForRequirements, assistantAskingForSchema,
    assistantAskingForSynopsis, systemInstruction, userSaying
} from "../../../../../../../ai/Utils";


export const generateSettingComponentsPrompt = (vars: {
    category: Setting,
    genres: string[],
    synopsis: string,
    setting?: string,
    context?: string[]
}) => {
    return systemInstruction("Ты профессиональный гейм-дизайнер")
        .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно подробно описать компонент сеттинга."))
        .concat(assistantAskingForGenre(vars.genres))
        .concat(assistantAskingForSynopsis(vars.synopsis))
        .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
        .concat(assistantAsking("Опиши категорию сеттинга", vars.category ? combineSettingDescription(vars.category) : undefined))
        .concat(assistantAskingForContext(vars.context))
        .concat(assistantAskingForInstructions([
            "Проанализируй краткое содержание (синопсис)",
            "Проанализируй описание сеттинга",
            "Проанализируй категорию сеттинга",
            "Проанализируй контекст",
            "Сгенерируй подробные компоненты сеттинга",
            "Придумай названия объектам если необходимо",
        ]))
        .concat(assistantAskingForRequirements([
            "Компоненты сеттинга должны быть подробным",
            "Компоненты сеттинга должны быть уникальными и соответствовать жанру",
            "Результат должен быть в формате json"
        ]))
        .concat(assistantAskingForSchema('{"data": [{"id":number, "title":string, "description":string}]}'))
        .concat(assistantAskingForExample({
            data: [
                {
                    id: 1,
                    title: "Флора",
                    description: "Гигантские деревья и цветы"
                },
                {
                    id: 2,
                    title: "Фауна",
                    description: "В основном мелкие животные"
                },
                {
                    id: 3,
                    title: "Погода",
                    description: "Вечный дождь"
                },
                {
                    id: 4,
                    title: "Циклы",
                    description: "День длится 3 часа, ночь 3 часа"
                }
            ]
        }))
        .concat(assistantAskingForAction(`Опиши сеттинг ${vars.category.title}
    
${vars.category.prompt.component.list}`));
}

export const generateSettingComponentPrompt = (vars: {
    category?: Setting,
    genres: string[],
    customPrompt?: string,
    synopsis?: string,
    setting?: string,
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно придумать компонент сеттинга."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши категорию сеттинга", vars.category ? combineSettingDescription(vars.category) : undefined))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй категорию сеттинга",
        "Проанализируй контекст",
        "Сгенерируй один компонент сеттинга",
        "Придумай названия объектам если необходимо",
        "Разбей текст на абзацы",
    ]))
    .concat(assistantAskingForRequirements([
        "Компонент сеттинга должен быть подробным",
        "Компонент сеттинга должен быть уникальным и соответствовать жанру",
        "Компонент сеттинга не должен повторяться с другими компонентами",
        "Используй все пять чувств для создания более живого описания компонента: запахи, звуки, текстуру, вкус и визуальные образы.",
        "Не применяй форматирование текста.",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Флора",
            description: "Гигантские деревья и цветы"
        }
    }))
    .concat(assistantAskingForAction(`Опиши компонент сеттинга из категории ${vars.category?.title} . ${vars.customPrompt ? ('\n\n' + vars.customPrompt) : ''}`))


export const improveSettingComponentPrompt = (vars: {
    genres: string[],
    customPrompt?: string,
    synopsis?: string,
    setting?: string,
    category: DraftComponentCategory
    component: DraftComponent,
    context?: string[]
}) => systemInstruction("Ты профессиональный гейм-дизайнер")
    .concat(userSaying("Я работаю над созданием сеттинга для литературного произведения. Нужно доработать и улучшить сеттинг."))
    .concat(assistantAskingForGenre(vars.genres))
    .concat(assistantAskingForSynopsis(vars.synopsis))
    .concat(assistantAsking("Опиши кратко сеттинг игры", vars.setting))
    .concat(assistantAsking("Опиши категорию сеттинга", vars.category.description))
    .concat(assistantAsking("Опиши компонент сеттинга", vars.component.description))
    .concat(assistantAskingForContext(vars.context))
    .concat(assistantAskingForInstructions([
        "Проанализируй краткое содержание (синопсис)",
        "Проанализируй описание сеттинга",
        "Проанализируй компонент сеттинга",
        "Проанализируй контекст",
        "Свяжи генерируемый компопнент с другими компонентами из контекста",
        "Наполни компонента сеттинга деталями",
        "Придумай названия объектам если необходимо",
        "Разбей текст на абзацы",
    ]))
    .concat(assistantAskingForRequirements([
        "Компопнент сеттинга должен быть подробным",
        "Компопнент сеттинга быть уникальным и соответствовать жанру",
        "Компопнент сеттинга не должен повторяться с другими компонентами",
        "Используй все пять чувств для создания более живого описания элемента: запахи, звуки, текстуру, вкус и визуальные образы.",
        "Не применяй форматирование текста.",
        "Результат должен быть в формате json",
    ]))
    .concat(assistantAskingForSchema('{"data": {"id":number, "title":string, "description":string}}'))
    .concat(assistantAskingForExample({
        data: {
            id: 1,
            title: "Флора",
            description: "Гигантские деревья и цветы"
        }
    }))
    .concat(assistantAskingForAction(`Нужно доработать и улучшить компонент сеттинга: ${JSON.stringify({
        title: vars.component.title,
        content: vars.component.description
    })}.
    
    ${vars.customPrompt}    
`))

